import { getCsCartListData , GetUserCartList } from "@/api/carts/carts";

export default {
    name: 'InventorySystem',
    
    data() {
        return {
            // ==================== 数据 ====================
            stores: [
                // { id: 1, name: '广州万博直营店', amount: 2388.62, type: 'direct' },
            ],
            products: [
                // { barcode: '6978068787994', name: '可爱云朵系列抱枕45cm', price: 23.94, quantity: 6, subtotal: 143.64, activity: '', expire: '01-28 18:10' },
            ],
            pages:{
                page:1,
                size:10,
                total:0
            },
            // ==================== 状态 ====================
            currentStoreInfo: {}, // 当前门店信息
            currentStoreId: 2,
            currentStoreName: '未选择',
            cartPrice: 0,
            cartNum: 0,

            isLoading: false,
            currentPage: 1,
            pageSize: 10,
            sortKey: '',
            sortOrder: 'asc',
            
            filters: {
                barcode: '',
                name: '',
                activity: '',
                expire: ''
            }
        };
    },    
    // ==================== 方法 ====================
    methods: {
        formatMoney(amount) {
            return amount.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        getCsUserList(){
            getCsCartListData({
                page:1,
                size:10
            }).then((response)=>{
                const {data} = response;
                for (let i = 0; i < data.data.length; i++) {
                    const element = data.data[i];
                    console.log(element)
                    this.stores.push({
                        id:element.id,
                        name:element.username,
                    })
                }
            })
        },
        selectStore(row) {
            const id = row.id;
            this.currentStoreId = id;
            this.currentStoreName = row.name;
            this.currentStoreInfo = row;
            GetUserCartList({
                uid:id,
                page:this.pages.page,
                size:this.pages.size
            }).then((response)=>{
                this.products = [];
                const {data} = response;
                let resdata =  data.data
                // console.log(resdata)
                this.pages.page = resdata.page
                this.pages.size = resdata.page_size
                this.pages.total = resdata.total

                this.cartPrice = resdata.price
                this.cartNum = resdata.total
                let listdata = resdata.data
                for (let i = 0; i < listdata.length; i++) {
                    const element = listdata[i];
                    this.products.push({
                        barcode:element.item_no,
                        name:element.item_name,
                        price:element.price,
                        quantity:element.num,
                        subtotal:element.total,
                        activity:"新品",
                    })
                }
                
            })
            // if (this.currentStoreId === id) return;
            // this.isLoading = true;
            // this.currentStoreId = id;
            // // 模拟API调用
            // setTimeout(() => {
            //     this.products = this.products.map(p => ({
            //         ...p,
            //         quantity: Math.floor(Math.random() * 20) + 1,
            //         subtotal: p.price * (Math.floor(Math.random() * 20) + 1)
            //     }));
            //     this.currentPage = 1;
            //     this.isLoading = false;
            // }, 300);

        },
        handleSizeChange(val) {
            alert(val)
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // alert(val)
            // console.log(`当前页: ${val}`);
            this.pages.page = val
            this.selectStore(this.currentStoreInfo)
        }
        
    },
    created() {
        this.getCsUserList();
    }
};